<template>
 <Header></Header>
  <div><el-image class="tbtp" :src="sf_dt"></el-image></div>
  <!-- <div v-if="sfd!=null">
    <div class="title">梳化系列</div>
    <div class="subtitle">可定制規格尺寸</div>
    <el-scrollbar>
      <ul class="infinite-list" style="height: 150px; white-space: nowrap">
        <li v-for="item of sfd" :key="item.index" class="infinite-list-item"  @click="openBox(item.prod_sn)">
          <el-image class="dl-tp" :src="item.url"></el-image>
          <div class="dl-wz">{{ item.prod_des }}</div>
        </li>
      </ul>
    </el-scrollbar>
  </div> -->
  <div v-if="sfc!=null" class="clearfix">
    <div class="title">{{category_des}}</div>
    <div class="subtitle">可定制規格尺寸</div>
    <div class="zp" v-for="item of sfc" :key="item.index" wx:key="index"  @click="openBox(item.prod_sn)">
      <el-image :src="item.url"></el-image>
      <div class="zpdes">{{ item.prod_des }}</div>
    </div>
  </div>
  <!-- <div v-if="yz!=null"> 
    <div class="title">椅子系列</div>
    <div class="subtitle">可定制規格尺寸</div>
    <el-scrollbar>
      <ul class="infinite-list" style="height: 150px; white-space: nowrap">
        <li v-for="item of yz" :key="item.index" class="infinite-list-item"  @click="openBox(item.prod_sn)">
          <el-image class="dl-tp" :src="item.url"></el-image>
          <div class="dl-wz">{{ item.prod_des }}</div>
        </li>
      </ul>
    </el-scrollbar>
  </div> -->
  <!-- <div v-if="jd!=null" class="clearfix">
    <div class="title">腳踏系列</div>
    <div class="subtitle">可定制規格尺寸</div>
    <div class="zp" v-for="item of jd" :key="item.index" wx:key="index"  @click="openBox(item.prod_sn)">
      <el-image :src="item.url"></el-image>
      <div class="zpdes">{{ item.prod_des }}</div>
    </div>
  </div> -->
  <Footer></Footer>
  <Box
  :dialogVisible="box.dialogVisible"
  :goods_id="box.goods_id"
  @close="boxClose"
></Box>
</template>

<script>
import Footer from "@/components/Footer_m";
import Header from "@/components/Header_m";
import Box from "@/components/Box_m";
export default {
  name: "sf_m",
  data() {
    return {
      sf_dt: "http://139.159.153.112:8200/gw_lmm/sf1_m.jpg",
      category_sn:"",
      category_des:"",
      sfc:[],
      yz:[],
      jd:null,
      sfd:[],
      box: {
        dialogVisible: false,
        goods_id: "",
      },
    };
  },
  components: { Footer,Header,Box },
    created(){
    if(sessionStorage.getItem("company_sn")!=null){
      this.company_sn=sessionStorage.getItem("company_sn")
      this.category_sn = this.$route.query.id;
      this.category_des=this.$route.query.des;
      this.queryProd()
    }
    },
  mounted() {
  },
  methods:{
    openBox(goods_id) {
      this.box.dialogVisible = true;
      this.box.goods_id = goods_id;
    },
    // 弹窗的搜索关闭
    boxClose(val) {
      this.box.dialogVisible = val;
    },
    // 查询推荐货品
    queryProd() {
      this.$api.queryprod({company_sn:this.company_sn,category_sn:this.category_sn,high:0}).then(
        res => {
          if (res.state == 10000) {
            this.sfc=res.data.prod
          } else {
            this.$message.error(res.msg);
          }
        },
        () => {
          this.$message.error("请求超时");
        }
      );
    },
  }
};
</script>

<style scoped>
.tbtp {
  height: 150px;
}
.title {
  margin-top: 25px;
  font-size: 22px;
  color: rgb(51, 51, 51);
}
.subtitle {
  font-size: 12px;
  line-height: 25px;
  color: rgb(51, 51, 51);
}

/* 單輪 */
.infinite-list {
  height: 180px;
  padding-left: 5px !important;
}
.infinite-list-item {
  display: inline-block;
  width: 200px;
  height: 150px;
  margin-right: 10px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}
.dl-tp {
  width: 200px;
  height: 115px;
}
.dl-wz {
  font-size: 13px;
}

/* 展示 */
.zp {
  float: left;
  width: 44vw;
  height: 50vw;
  margin-left: 2.8vw;
  margin-top: 4vw;
  border-radius: 5px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.1);
}
.zp .el-image {
  width: 44vw;
  height: 40vw;
}
.zpdes {
  font-size: 13px;
}
</style>